import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import uuidv4 from 'uuid/v4';
import Commitment from './Commitment';
import CoolfooderInfos from './CoolfooderInfos';
import FirstCommitStep from './FirstCommitStep';
import CommitmentModal from './CommitmentModal';
import ConfirmCommits from './ConfirmCommits';
import Congratulation from './Congratulation';
import ProgressIndicator from './ProgressIndicator';
import Helper from './Helper';
import SmallScreen from './SmallScreen';
import SwipeableViews from 'react-swipeable-views';

import { Dialog, Modal, ClickAwayListener } from '@material-ui/core';
import { string } from 'postcss-selector-parser';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2)
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  swiperContainer: {
    flex: '1 1 auto',
    paddingRight: theme.spacing(2),
    maxWidth: 690
  },
  infosContainer: {
    flex: '1 1 auto',
    width: 300,
    position: 'relative'
  },
  floating: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}));

export default function CommitProcess({ happening, lang }) {
  // console.log('DRAW COMMITMENT PROCESS');

  const [globalState, globalDispatch] = useCoolfoodContext();

  const [showScreen, setShowScreen] = useState(false);

  const isMD = useMediaQuery('(min-width:1024px)');
  const isPhone = useMediaQuery('(max-width:960px)');

  // Hook executed each time the happening data change (it would not arrive)
  // Store informations into store
  useEffect(() => {
    globalDispatch({ type: actions.SET_HAPPENING, happening });
  }, [globalDispatch, happening]);

  // At init, check global variables about coolfooder, id and commits already taken, and register them in store if exist
  useEffect(() => {
    // Register coolfooder informations if user is logged in in wordpress
    const coolfooderInfos = {};

    // If user id globally set
    if (window._uuid) {
      coolfooderInfos.exists = window._exists;
    }

    // If user has already taken commitments passed globally as string, build an array and register it
    if (window._cids) {
      coolfooderInfos.commitsAlreadyTaken = window._cids.map(Number);
    }

    // Object is populated, register it
    if (JSON.stringify(coolfooderInfos) !== '{}') {
      globalDispatch({
        type: actions.SET_COOLFOODER_INFOS,
        infos: coolfooderInfos
      });
    }

    // Store lang from happening language
    globalDispatch({
      type: actions.SET_LANG,
      lang
    });
  }, [globalDispatch, lang]);

  const classes = useStyles();

  const [swiperViews, setSwiperViews] = useState(null);

  useEffect(() => {
    // If happening not initialized, return empty slide
    if (!globalState.happening) {
      setSwiperViews(<div />);
      return;
    }
    const views = [];
    views.push(<FirstCommitStep key="FirstCommitStep" />);
    const { commitments } = globalState.happening;
    globalState.selectedCommitments.forEach(id => {
      const commitment = commitments.find(c => c.id === id);
      if (commitment) {
        views.push(<Commitment key={commitment.id} definition={commitment} />);
      }
    });
    views.push(<ConfirmCommits key="ConfirmCommits" />);
    if (!window._uuid) {
      views.push(<CoolfooderInfos key="CoolfooderInfos" />);
    }
    views.push(<Congratulation key="Congratulation" />);
    let fakeViews = [];
    for (let i = 0; i < views.length; i++) {
      if (i === globalState.currentSlide) {
        fakeViews.push(views[i]);
      } else {
        fakeViews.push(<div key={uuidv4()} />);
      }
    }
    setSwiperViews(fakeViews);
  }, [
    globalState.currentSlide,
    globalState.happening,
    globalState.selectedCommitments
  ]);

  useEffect(() => {
    if (globalState.commitsValidated && !isMD) {
      setShowScreen(true);
    }
  }, [globalState.commitsValidated, isMD]);

  const scrollUp = () => {
    const el = document.getElementById('primary');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className={classes.root}>
      {globalState.happening && globalState.happening.commitments && (
        <>
          <div className={classes.mainContainer}>
            <div className={classes.swiperContainer}>
              <SwipeableViews
                index={globalState.currentSlide}
                onTransitionEnd={scrollUp}
                disabled
              >
                {swiperViews}
              </SwipeableViews>
              <ProgressIndicator />
            </div>
            <div className={classes.infosContainer}>
              {isMD && <SmallScreen />}
              {globalState.language === 'fr' && <Helper />}
            </div>
          </div>
          {globalState.commitmentModal && (
            <Dialog
              open={!!globalState.commitmentModal}
              onClose={() => {
                globalDispatch({ type: actions.SHOW_MODAL, id: 0 });
              }}
              fullWidth
              fullScreen={isPhone}
              maxWidth="md"
            >
              <CommitmentModal />
            </Dialog>
          )}
          <Modal open={showScreen}>
            <div>
              <ClickAwayListener onClickAway={() => setShowScreen(false)}>
                <div>
                  <SmallScreen className={classes.floating} />
                </div>
              </ClickAwayListener>
            </div>
          </Modal>
        </>
      )}
      {/* <Intro /> */}
    </div>
  );
}

CommitProcess.propTypes = {
  happening: PropTypes.shape(),
  lang: string, 
};
